import yxpapi from '@/extlib/yxpapi';
import config from '@/config';
import api from '@/axios/commonApi.js';
import { $concurrent } from '@/lib/functional.js';

const stroage = yxpapi.stroage;

yxpapi.store.registerModule('system', {
    namespaced: true,
    state: {
        superAuth: stroage['persistent'].get('system.superAuth') || false, // 从后台列表进入前台页面拥有超级权限
        siteList: stroage['persistent'].get('system.siteList') || [], // 前台站点列表
        routerStatus: 'not-set', // 路由状态
        routerList: null, // 最终路由
        appId: config.appId,
        appCode: config.appCode,
        actionCodes: stroage['persistent'].get('system.actionCodes') || [],
        permissionTypes: { // 权限类型
            [config.appId]: config.permissionType,
        }, // 权限类型 data: 数据权限；action：功能权限
        dataPermissionCode: {
            [config.appId]: config.dataPermissionCode,
        }, // 数据权限模块code
        dataActionCode: {
            [config.appId]: config.dataActionCode, // 数据权限
        }, // 数据权限操作code
        flatTreeList: [],
        webSiteOrgId: '1',
        webSiteOrgType: 0,
        docmentHidden: false,
    },
    actions: {
        act_clearAccount ({ commit, dispatch }) {
            dispatch('global/loginOut', null, { root: true });
            commit('mu_clear_login');
        },
        act_login_off ({ commit, dispatch, rootGetters }, param = {}) {
            if (process.env.NODE_ENV === 'development') {
                api.saveIdentity({
                    orgId: rootGetters['global/orgId'],
                    identityId: rootGetters['global/userIdentity'],
                    userId: rootGetters['global/userId'],
                    uuid: -1,
                });
            }
            dispatch('act_clearAccount');
            dispatch('global/nav/loginOff', param, { root: true });
        },
        act_backToIndex (store, param = {}) {
            let addr = store.rootGetters['global/nav/loginAddress']; // wake
            window.location.href = `${addr.origin + addr.pathname}#/index`;
        },
        /* 应用授权 */
        actAuthorize (store) {
            let { commit, dispatch, getters, rootGetters } = store;
            /* 清空权限 */
            commit('mu_clearActionCodes');
            return Promise.all([
                dispatch('getActionForApp'),
                $concurrent(config.beforeAuthorize, 4, store),
            ]).then(() => {
                if (getters['clientPermission'] || getters['permission']) { // 权限验证通过
                    return true;
                } else { // 无权访问
                    if (process.env.NODE_ENV === 'development') {
                        api.saveIdentity({
                            orgId: rootGetters['global/orgId'],
                            identityId: rootGetters['global/userIdentity'],
                            userId: rootGetters['global/userId'],
                            uuid: -1,
                        });
                    }
                    return Promise.reject(new Error());
                }
            }).catch(e => {
                this.loadError(e.errmsg || '请重新登录！');
            });
        },
        /* 获取当前应用的权限 */
        getActionForApp ({ commit, dispatch, getters, rootGetters }) {
            let currentApp = getters['currentApp'];
            // 1:data 数据范围授权
            if (currentApp.privilegeType === 1) {
                return api.getActionList({
                    appCode: getters['appCode'],
                }).then(data => {
                    if (data.errcode === 0) {
                        commit('mu_actionCodes', data.data.list);
                    } else {
                        return Promise.reject(data);
                    }
                });
            } else {
                return Promise.resolve();
            }
        },
    },
    mutations: {
        mu_superAuth (state, data) {
            state.superAuth = data;
            stroage['persistent'].set('system.superAuth', state.superAuth);
        },
        mu_siteList (state, data) {
            state.siteList = data;
            stroage['persistent'].set('system.siteList', state.siteList);
        },
        mu_redirection (state, redirection = '') { // 重置redirection
            state.redirection = redirection;
            stroage.session.set('system.redirection', state.redirection);
        },
        mu_appId (state, appId) {
            state.appId = appId;
            stroage.persistent.set('system.yxpAppId', state.appId);
        },
        /* 添加模块权限 */
        mu_actionCodes (state, action = []) {
            state.actionCodes = state.actionCodes.concat(action);
            stroage['persistent'].set('system.actionCodes', state.actionCodes);
        },
        /* 添加模块权限 */
        set_actionCodes (state, action = []) {
            state.actionCodes = action;
            stroage['persistent'].set('system.actionCodes', state.actionCodes);
        },
        /* 重置模块权限 */
        mu_clearActionCodes (state) {
            state.actionCodes = [];
            stroage['persistent'].set('system.actionCodes', state.actionCodes);
        },
        mu_routerList (state, payload = []) {
            state.routerStatus = 'ready';
            state.routerList = payload;
            stroage['persistent'].set('system.routerList', state.routerList);
        },
        mu_clear_login (state) {
            stroage['persistent'].remove('system');
            stroage['persistent'].remove('yxpNav');
            stroage['persistent'].remove('yxpPermission');
        },
        mu_flatTreeList (state, payload) {
            state.flatTreeList = payload;
        },
        mu_webSiteOrgId (state, payload) {
            state.webSiteOrgId = payload;
        },
        mu_webSiteOrgType (state, payload) {
            state.webSiteOrgType = payload;
        },
        mu_docmentHidden (state, payload) {
            state.docmentHidden = payload;
        },
    },
    getters: {
        getSuperAuth (state) {
            return state.superAuth || false;
        },
        getSiteList (state) {
            return state.siteList || [];
        },
        access (state) {
            let accessCode = [];
            (state.actionCodes || []).forEach(mod => {
                accessCode.push(...(mod.actions || []).map(a => a.code));
            });
            return accessCode;
        },
        routerList (state) {
            return state.routerList || [];
        },
        appId (state) {
            return state.appId;
        },
        appCode (state) {
            return state.appCode;
        },
        currentApp (state, getters, rootState, rootGetters) {
            let appList = rootGetters['permission/appList'] || [];
            return appList.find(itm => itm.appId === state.appId) || {};
        },
        permissionType (state, getters) {
            let currentApp = getters['currentApp'];
            if (currentApp.privilegeType !== 1) return 'none'; // 无需验证权限
            return state.permissionTypes[getters.appId];
        },
        permission (state, getters) { // 权限验证
            if (getters.permissionType === 'data') {
                let tmp = state.actionCodes.filter((itm) => {
                    return itm.authType !== 'custom'; // 去掉前台权限
                });
                return tmp.length > 0;
                //     action = module.actions.find(b => b.code === state.dataActionCode[getters.appId]) || { dataRules: [] };
                // return action.hasAllPermission || action.dataRules.length > 0;
            } else if (getters.permissionType === 'action') {
                return getters.access.filter(itm => itm.substring(itm.length - 3) === '001').length > 0;
            } else {
                return true;
            }
        },
        clientPermission (state, getters, rootState, rootGetters) { // 可访问前台权限验证
            return !!config.clientPermission && config.clientPermission(...arguments);
        },
        redirection (state) { // 首页重定向地址
            return !!config.redirection && config.redirection(...arguments);
        },
        getFlatTreeList (state) {
            return state.flatTreeList;
        },
        getWebSiteOrgId (state) {
            return state.webSiteOrgId;
        },
        getWebSiteOrgType (state) {
            return state.webSiteOrgType;
        },
        getDocmentHidden (state) {
            return state.docmentHidden;
        },
    },
});
